<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menu" slot-scope="scope">
        <el-button type="text"
                   size="small"
                   icon="el-icon-edit"
                   @click="opneTableDesion(scope.row)">扩展表设计
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/custom-form-main/customformmain";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          indexLabel: '编号',
          align: 'center',
          column: [
            {
              label: "页面标识",
              prop: "pageUrl",
              rules: [{
                required: true,
                message: "请输入页面标识",
                trigger: "change"
              }]
            },
            {
              label: "标准表名",
              prop: "mainTable",
              rules: [{
                required: true,
                message: "请输入标准表名",
                trigger: "change"
              }]
            },
            {
              label: "表单编号",
              prop: "formCode",
              rules: [{
                required: true,
                message: "请输入表单编号",
                trigger: "change"
              }]
            },
            /*{
              label: "标准表单json",
              prop: "createJson",
              hide: true,
              rules: [{
                required: true,
                message: "请输入标准表单json",
                trigger: "change"
              }]
            },*/
            {
              label: "备注",
              prop: "comment",
              rules: [{
                required: true,
                message: "请输入备注",
                trigger: "change"
              }]
            },
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.customformmain_add, false),
          viewBtn: this.vaildData(this.permission.customformmain_view, false),
          delBtn: this.vaildData(this.permission.customformmain_delete, false),
          editBtn: this.vaildData(this.permission.customformmain_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      opneTableDesion(rowData) {
        console.log(rowData.pageUrl);
        this.$router.push(
          `/table-extension/table-extension-design?pageUrl=${encodeURI(rowData.pageUrl)}`
        );
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
